import React from "react";
import TextBlock from "../../NotFound/NotFoundBlock/TextBlock/TextBlock";
import redCross from "../../../images/red-cross.png";

const ErrorBlock = (props) => {
  return (
    <div className="notFoundBlock rounded-lg p-5 ml-auto mr-auto mt-4 relative">
      <div className="redCross">
        <img src={redCross} alt="" />
      </div>
      <div className="flex flex-col">
        <div>
          <TextBlock
            big
            content={props.title}
            customStyle={{ color: "rgb(246,61,74)" }}
          />
        </div>
        <div className="mt-8">
          <TextBlock
            content={props.subTitle}
            customStyle={{ color: "rgb(246,61,74)" }}
          />
        </div>

        <div className="mt-10">
          <TextBlock
            content="How to fix this"
            customStyle={{ color: "rgb(0, 122, 255)" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorBlock;
